module.exports = __webpack_public_path__ + "img/12.d7f2a5d0.png";